<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改收款</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">修改收款记录</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal">

        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            <!-- 客户信息 -->
            <el-form-item label="客户名称：" prop="customerId">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>

            <!-- 项目信息 -->
            <el-form-item label="成交项目：" prop="projectId">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>

            <!-- 收支类型 -->
            <el-form-item label="收支类型：" prop="type">
              <el-radio-group v-model="form.type" disabled>
                <el-radio :label="1">收款</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 总金额 -->
            <el-form-item label="总金额：" prop="totalAmount">
              <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="2" :step="100" placeholder="请输入金额" style="width: 70%"></el-input-number>
            </el-form-item>

            <!-- 收款账户 -->
            <el-form-item label="收款账户：" prop="payAccount">
              <el-select v-model="form.payAccount" placeholder="请选择收款账户" style="width: 100%">
                <el-option v-for="item in payAccountList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 钱款类型 -->
            <el-form-item label="钱款类型:" prop="payType">
              <el-radio-group v-model="form.payType" size="small">
                <el-radio-button v-for="item in payTypeList" :key="item" :label="item">{{ item }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 收款日期 -->
            <el-form-item label="收款日期：" prop="payDate">
              <el-date-picker
                v-model="form.payDate"
                :disabled="payDateReadonly()"
                type="date"
                placeholder="请选择收款日期"
                style="width: 100%"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注：" prop="remark">
              <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息（选填，最多500字符）" maxlength="500"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="okClickHandler">确定</el-button>
              <el-button @click="goBack">返回</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="16" :offset="0">
            <!-- 附件上传 -->
            <el-form-item label="附件：">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleUploadSuccess"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
              :before-upload="beforeUpload"
              :file-list="fileList"
              list-type="picture-card">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">支持图片、PDF等文件格式</div>
            </el-upload>
          </el-form-item>

          <!-- 操作记录（detail 接口附带；置于附件下方，利用右栏剩余空间避免页面翻页） -->
          <div v-if="operationLogs.length > 0" style="margin-top: 10px;">
            <div style="font-weight: bold; margin-bottom: 10px;">操作记录</div>
            <el-table :data="operationLogs" border size="mini" max-height="calc(100vh - 340px)">
              <el-table-column label="动作" width="120">
                <template slot-scope="scope">{{ actionText(scope.row.action) }}</template>
              </el-table-column>
              <el-table-column prop="operatorName" label="操作人" width="90"></el-table-column>
              <el-table-column prop="remark" label="说明" min-width="180" show-overflow-tooltip></el-table-column>
              <el-table-column label="时间" width="140">
                <template slot-scope="scope">{{ scope.row.createDate | timeFormat }}</template>
              </el-table-column>
            </el-table>
          </div>

          </el-col>
        </el-row>

      </el-form>

    </el-card>

    <!-- PDF预览对话框 -->
    <el-dialog :visible.sync="pdfPreviewDialogVisible" width="60%" :title="previewTitle">
      <div class="preview-container" style="height: 600px;">
        <iframe :src="previewUrl" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image
      v-show="false"
      ref="imageViewer"
      :src="currentImageUrl"
      :preview-src-list="imagePreviewList">
    </el-image>

  </div>
</template>

<script>
import { payTypeList, payAccountList } from '@/utility/staticData'
import { actionText } from '../../utils/operationLogMap'
export default {
  filters: {
    timeFormat (val) {
      if (!val) return '-'
      const d = new Date(val)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  },
  data () {
    return {
      // 操作日志（detail 接口附带）
      operationLogs: [],
      actionText,
      form: {
        customerId: '',
        customerName: '',

        type: 0,
        payType: '',
        payAccount: '',
        totalAmount: 0,
        payDate: '',

        projectId: '',
        projectName: '',

        attachments: [],
        remark: ''
      },

      formRules: {
        payType: { required: true, message: '请选择支付方式', trigger: 'change' },
        payAccount: { required: true, message: '请选择收款账户', trigger: 'change' },
        remark: { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' }
      },

      // 列表数据
      payTypeList: payTypeList.filter(item => item !== '退款'),
      payAccountList: payAccountList,

      // 上传使用
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      fileList: [],

      // 预览相关
      pdfPreviewDialogVisible: false,
      previewUrl: '',
      previewTitle: '',
      currentImageUrl: '',
      imagePreviewList: [],

      // PDF 图标路径
      pdfIconUrl: require('@/assets/pdf.png'),

      // 用于预览的基础url
      base: '',
      accountInfo: {}
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    this.getAccountInfo()
    this.getDetail()
  },
  methods: {
    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
      this.accountInfo.bindDxqId = window.sessionStorage.getItem('bindDxqId') || ''
    },

    // 判断付款日期是否为只读状态
    payDateReadonly () {
      return this.accountInfo.level > 1 && this.accountInfo.job !== '总监'
    },

    // 获取财务记录详情
    async getDetail () {
      try {
        const { data: res } = await this.$http.get(`zhaoshang/customerBill/detail/${this.$route.params.id}`)
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          this.$router.push('/zhaoshang/customer?tabs=financial')
          return
        }

        // 操作记录（detail 接口附带，最近 20 条）
        this.operationLogs = res.data.operationLogs || []

        // 填充表单数据
        const detail = res.data
        this.form.customerId = detail.customerId
        this.form.customerName = detail.customerName
        this.form.projectId = detail.projectId
        this.form.projectName = detail.projectName

        this.form.type = detail.type
        this.form.payType = detail.payType
        this.form.payAccount = detail.payAccount
        this.form.totalAmount = detail.totalAmount
        this.form.payDate = this.$getDate(detail.payDate)

        this.form.remark = detail.remark || ''
        this.form.attachments = detail.attachments || []

        // 构建文件列表用于显示
        this.buildFileList()
      } catch (error) {
        this.$message.error('获取财务记录详情失败')
        this.$router.push('/zhaoshang/customer?tabs=financial')
      }
    },

    // 构建文件列表用于显示
    buildFileList () {
      const baseUrl = this.base
      this.fileList = this.form.attachments.map((item, index) => {
        const fileType = this.getFileType(item.name)
        const fileUrl = baseUrl + item.url

        if (fileType === 'pdf') {
          // PDF文件显示自定义图标
          return {
            name: item.name,
            url: this.pdfIconUrl,
            actualUrl: fileUrl,
            uid: Date.now() + index
          }
        } else {
          // 图片文件显示缩略图
          return {
            name: item.name,
            url: fileUrl,
            uid: Date.now() + index
          }
        }
      })
    },

    // 判断文件类型
    getFileType (fileName) {
      const ext = fileName.toLowerCase().split('.').pop()
      const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const pdfExts = ['pdf']

      if (imageExts.includes(ext)) return 'image'
      if (pdfExts.includes(ext)) return 'pdf'
      return 'other'
    },

    // 上传前校验
    beforeUpload (file) {
      const fileType = this.getFileType(file.name)
      const isValidType = ['image', 'pdf'].includes(fileType)

      if (!isValidType) {
        this.$message.error('只支持上传图片或PDF文件')
        return false
      }

      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      return true
    },

    // 上传成功
    handleUploadSuccess (res, file, fileList) {
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      const fileType = this.getFileType(file.name)
      const baseUrl = this.base

      // 为PDF文件设置自定义图标
      if (fileType === 'pdf') {
        const fileItem = fileList[fileList.length - 1]
        fileItem.url = this.pdfIconUrl // 用于显示图标
        fileItem.actualUrl = baseUrl + res.data.url // 保存实际文件地址用于预览
      }

      this.form.attachments.push({
        url: res.data.url,
        name: file.name,
        type: fileType
      })
      this.fileList = fileList
    },

    // 删除文件
    handleRemove (file, fileList) {
      const index = this.fileList.indexOf(file)
      if (index !== -1 && this.form.attachments[index]) {
        this.form.attachments.splice(index, 1)
      }
      this.fileList = fileList
    },

    // 预览文件
    handlePreview (file) {
      const attachment = this.form.attachments.find(item => item.name === file.name)
      if (!attachment) return

      const baseUrl = this.base
      const fileUrl = baseUrl + attachment.url

      console.log(fileUrl)

      this.previewTitle = file.name

      if (attachment.type === 'image') {
        // 使用 Element UI 的图片预览
        this.buildImagePreviewList()
        this.currentImageUrl = fileUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      } else if (attachment.type === 'pdf') {
        // PDF使用对话框预览
        this.previewUrl = file.actualUrl || fileUrl
        this.pdfPreviewDialogVisible = true
      }
    },

    // 构建图片预览列表
    buildImagePreviewList () {
      const baseUrl = this.base
      this.imagePreviewList = this.form.attachments
        .filter(item => item.type === 'image')
        .map(item => baseUrl + item.url)
    },

    // 点击添加按钮
    async okClickHandler () {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        const submitData = {
          payType: this.form.payType,
          payAccount: this.form.payAccount,
          attachments: this.form.attachments,
          remark: this.form.remark || '',
          payDate: this.form.payDate
        }

        try {
          const { data: res } = await this.$http.put(`zhaoshang/customerBill/modifyIncome/${this.$route.params.id}`, submitData)
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          console.error('添加财务记录失败:', error)
          this.$message.error('添加财务记录失败')
        }
      })
    },

    // 返回
    goBack () {
      // 获取传递过来的状态参数
      const query = { ...this.$route.query }

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : '?tabs=financial'

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

// 自定义上传列表中的PDF图标样式
::v-deep .el-upload-list__item-thumbnail {
  object-fit: contain;
}

// 图片预览样式优化
::v-deep .el-image-viewer__wrapper {
  z-index: 3000;
}
</style>
